import { createBtnWithSpinner, createEl, createElWithText, createFragment } from "../../../helpers/dom-creators.js";
import { $, _ } from "../../../helpers/dom-selectors.js";
import emitGlobalFormEventWithData from "../../../helpers/form-events.js";
import Overlay from "../overlay.js";
export default function makeReOrderModal({ overlayEl, entity }) {
    let initialized = false;
    let PROMPT;
    return Object.freeze({
        init,
        showModal
    });
    function init() {
        if (initialized)
            return;
        PROMPT = new Overlay(overlayEl);
        initialized = true;
    }
    function showModal(items) {
        const fragments = [];
        fragments.push(createElWithText('h1', 'text-center no-margin', `Reorder ${entity}s`), createElWithText('p', 'text-center no-margin', `Drag and drop the ${entity.toLowerCase()}s below to reorder.`));
        const wrapper = createEl('div', 'reorder-wrapper flex-container flex-col flex-center');
        items.forEach(item => {
            const itemEl = createElWithText('div', 'reorder-item text-center draggable', item.title, { draggable: 'true', "data-id": item.id });
            wrapper.append(itemEl);
        });
        fragments.push(wrapper, createBtnWithSpinner('btns submit-btn', { id: 'submitReorderBtn', type: 'button', text: 'Update Order', title: 'Update Order' }));
        const fragment = createFragment(fragments);
        PROMPT.render(fragment);
        _addListeners();
    }
    function _addListeners() {
        const dragContainer = $(overlayEl, '.reorder-wrapper')[0];
        const draggables = $(dragContainer, '.reorder-item');
        draggables.forEach(draggable => {
            draggable.addEventListener('dragstart', _onDragStart);
            draggable.addEventListener('dragend', _onDragEnd);
        });
        dragContainer.addEventListener('dragover', _onDragOver);
        _('submitReorderBtn')?.addEventListener('click', _onSubmitOrder);
    }
    function _onDragStart() {
        this.classList.add('dragging');
    }
    function _onDragEnd() {
        this.classList.remove('dragging');
    }
    function _onDragOver(e) {
        e.preventDefault();
        const dragContainer = e.currentTarget;
        const afterElement = _getDragAfterElement(dragContainer, e.clientY).element;
        const draggable = $(dragContainer, '.dragging')[0];
        if (afterElement == null) {
            dragContainer.appendChild(draggable);
        }
        else {
            dragContainer.insertBefore(draggable, afterElement);
        }
    }
    function _getDragAfterElement(container, y) {
        const draggableElements = [...$(container, '.draggable:not(.dragging)')];
        const result = draggableElements.reduce((closest, child) => {
            const box = child.getBoundingClientRect();
            const offset = y - box.top - box.height / 2;
            if (offset < 0 && offset > closest.offset) {
                return { offset, element: child };
            }
            else {
                return closest;
            }
        }, { offset: Number.NEGATIVE_INFINITY });
        return result;
    }
    function _onSubmitOrder() {
        const dragContainer = $(overlayEl, '.reorder-wrapper')[0];
        const draggables = $(dragContainer, '.reorder-item');
        const events = [];
        draggables.forEach((item, i) => {
            events.push({
                id: item.getAttribute('data-id'),
                orderIndex: i
            });
        });
        emitGlobalFormEventWithData('entities-reordered', {
            submitBtn: this,
            entities: events
        });
    }
}
